import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'eos-comment-confirmation',
  templateUrl: './comment-confirmation.component.html',
  encapsulation: ViewEncapsulation.None,
  styles: [`
    .custom-class.modal{
      z-index:9999;
    }
  `]
})
export class CommentConfirmationComponent implements OnInit {
  @Input() public header: string;
  content=''
  constructor(public modal: NgbActiveModal) { }

  ngOnInit() {
  }
  onNoButtonClick() {
    this.modal.dismiss('noButtonClick');
  }

}
